import styled from 'styled-components';
import { Row } from '@simplywallst/ui-core';

export const Wrapper = styled(Row)`
  width: 100%;
`;

export const Bar = styled.div`
  position: relative;
  max-width: ${({ theme }) => theme.xlMin};
  width: 100%;
`;
